var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlgorand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8521_4686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3613 60L19.0552 44.9702L27.7253 30.0119L36.3478 14.9821L37.7769 12.6002L38.42 14.9821L41.0639 24.867L38.0865 30.0119L29.4164 44.9702L20.794 60H31.179L39.8491 44.9702L44.3509 37.2052L46.447 44.9702L50.4724 60H59.7856L55.7602 44.9702L51.7586 30.0119L50.6868 26.1294L57.1417 14.9821H47.7332L47.4236 13.8626L44.1366 1.59587L43.7078 0H34.6566L34.4422 0.309647L25.9865 14.9821L17.2926 30.0119L8.67011 44.9702L0 60H10.3613Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8521_4686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.7856,
    height: 60,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgorand);
export default __webpack_public_path__ + "static/media/algorand.17569f6c1bf3e5f4a70c11fc09bee4ba.svg";
export { ForwardRef as ReactComponent };